var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.termsOfUseUrl,"rel":"noopener noreferrer","target":"_blank"}},[_vm._v("Legal")])}
var staticRenderFns = []

export { render, staticRenderFns }